const toCamelCaseKey = (key: string) =>
    key.length ? key.charAt(0).toLowerCase() + key.slice(1) : key

export const keysToCamelCase = (value: any): any => {
    if (Array.isArray(value)) {
        return value.map(item => keysToCamelCase(item))
    }
    if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
        return Object.keys(value).reduce((acc, key) => {
            acc[toCamelCaseKey(key)] = keysToCamelCase(value[key])
            return acc
        }, {} as Record<string, any>)
    }
    return value
}
